export default __webpack_public_path__ + "969ae793f6640fe555ae7e1a82798a18.pdf";